<template>
  <v-select
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="Club Fitter"
    item-text="displayName"
    item-value="id"
    :disabled="disabled"
    :rules="rules"
    :clearable="clearable"
  ></v-select>
</template>

<script>
export default {
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: {
    value: {
      type: Number
    },
    disabled: {
      type: Boolean,

    },
    rules: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    model() {
      this.$emit("input", this.model);
    }
  },
  mounted: function() {
    this.getFittingType();
  },
  methods: {
    getFittingType() {
      this.$store
        .dispatch("users/list", {filter:{
          "role" : [1,2,3,4,5,6,7,8,9,10]
        }})
        .then(({users}) => {
          this.items = users.data;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
